/* eslint-disable max-classes-per-file*/
import { Container } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

export class TfnValueConverter {
	private i18n: I18N;

	constructor() {
		this.i18n = Container.instance.get(I18N);
	}

	public toView(modifiedModel, originalModel) {
		if (!modifiedModel || !modifiedModel.value) {
			return '';
		}
		const viewStr = this.i18n.tr(modifiedModel.value);
		if (originalModel && originalModel.value) {
			return viewStr + ' - ' + this.i18n.tr(originalModel.value);
		}
		return viewStr;
	}
}

// tslint:disable:max-classes-per-file
export class TfnInvalidValueConverter {
	private i18n: I18N;

	constructor() {
		this.i18n = Container.instance.get(I18N);
	}

	public toView(fieldModel) {
		return fieldModel.value != null &&
			typeof fieldModel.value === 'string' &&
			fieldModel.value.trim() === 'Y'
			? this.i18n.tr('tfn.invalid')
			: this.i18n.tr('tfn.valid');
	}
}
